import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight'
import { Box, styled, SxProps, Typography, useTheme } from '@mui/material'

type LinkAnimationProps = {
  link: string
  text: string
  externalLink?: boolean
  sx?: SxProps
}

const BannerLink = styled(Link)`
  ${({ theme }) => `
    display: inline-block;
    position: relative;

    :after {
      width: 0;
      height: 3px;
      background: #96f3f7;
      border-radius: 18px;
      bottom: -5px;
      content: '';
      position: absolute;
      right: 0;
      transition: ${theme.transitions.create('width', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeOut
      })};
    }

    :hover:after {
      width: 100%;
      left: 0;
      right: auto;
    }
  `}
`

const renderTextAndIcon = (text: string, sx?: SxProps) => {
  const { palette } = useTheme()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography
        sx={{
          fontSize: { mobile: 24 },
          fontWeight: 'bold',
          lineHeight: 1.4,
          mr: 2,
          ...sx
        }}
      >
        {text}
      </Typography>
      <Box
        component={FontAwesomeIcon}
        icon={faAngleRight}
        color={palette.info.main}
        sx={{ height: { xs: 22, mobile: 34 } }}
      />
    </Box>
  )
}

export const LinkAnimation = ({
  link,
  text,
  externalLink,
  sx
}: LinkAnimationProps) => {
  if (externalLink) return <a href={link}>{renderTextAndIcon(text, sx)}</a>

  return <BannerLink to={link}>{renderTextAndIcon(text, sx)}</BannerLink>
}
